import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SafeAreaView } from 'react-native-safe-area-context';

import SelectPhoneOrEmail from '../../components/register/SelectPhoneOrEmail';
import Languages from '../../constants/Languages';
import * as Actions from '../../store/Actions';
import getInstallationIdAsync from '../../utils/getInstallationIdAsync';

class PhoneOrEmailScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  checkEmailOrPhone = async (searchString) => {
    const { actions, registration, navigation } = this.props;
    const { language } = registration;
    const deviceId = await getInstallationIdAsync();
    actions.checkEmailOrPhone(searchString, deviceId, language.name, (nextScreen) => {
      navigation.navigate(nextScreen);
    });
  };

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  render() {
    const { registration, actions } = this.props;
    const { language, emailOrPhoneError } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <SelectPhoneOrEmail
          translation={translation}
          goBack={this.goBack}
          goNext={this.checkEmailOrPhone}
          inputError={emailOrPhoneError}
          actions={actions}
        />
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneOrEmailScreen);
